import Vue from 'vue';
import downLoadButton from '@/components/element/downloadButton.vue';
import downloadProgress from '@/components/element/downloadProgress.vue';
import { PACKAGE_SYNCER_MODES } from '@/tools/consts';
import { commandTypes } from '@/types';

const DownLoadButton = Vue.extend(downLoadButton);
const DownloadProgress = Vue.extend(downloadProgress);
export default {
	init() {
		if (
			!(
				this.$store.state.packageSyncer.isSyncerApp &&
				(this.$store.state.packageSyncer.mode === PACKAGE_SYNCER_MODES.tour ||
					this.$store.state.packageSyncer.mode === PACKAGE_SYNCER_MODES.exhibition)
			)
		) {
			return;
		}

		const $posts = [
			...this.$el.querySelectorAll(
				'.post[data-url^="command://startTour"]:not([data-url$="noOfflineSync=true"])'
			),
			...this.$el.querySelectorAll('.post[data-url^="command://loadExhibition"]'),
		];
		$posts.forEach($post => {
			const id = $post
				.getAttribute('data-url')
				.trim()
				.match(/(startTour|loadExhibition)\?id=([^|&]*)/)[2];
			const command = $post
				.getAttribute('data-url')
				.trim()
				.match(/(startTour|loadExhibition)\?id=([^|&]*)/)[1];
			$post.setAttribute('sub-part-id', id);
			$posts.forEach($post => {
				$post.setAttribute(
					'sub-part-state',
					this.$store.state.packageSyncer.subPartStates[$post.getAttribute('sub-part-id')]
				);
			});
			if (
				(this.$store.state.packageSyncer.mode === PACKAGE_SYNCER_MODES.tour &&
					command === commandTypes.startTour) ||
				(this.$store.state.packageSyncer.mode === PACKAGE_SYNCER_MODES.exhibition &&
					command === commandTypes.loadExhibition)
			) {
				const button = new DownLoadButton({
					store: this.$store,
					propsData: { subPartId: id },
				}).$mount();
				$post.appendChild(button.$el);
				const progress = new DownloadProgress({
					store: this.$store,
					propsData: { subPartId: id },
				}).$mount();
				$post.appendChild(progress.$el);
			}
		});
	},
};
